<template>
  <div class="sheet-menu">
    <el-tabs v-model="activeName" ref="sheetMenu" class="display">
      <el-tab-pane
        v-for="(menu, index) in menuList.slice(0, displayIndex)"
        :key="index"
        :name="menu.name"
      >
        <template v-slot:label>
          <div style="display: flex" @click="select(menu)">
            <div class="nav-label" v-tip>
              {{
                menu.type === "ref"
                  ? menu.name.slice(0, menu.name.length - menu.dataIds.length.toString().length - 2)
                  : menu.name
              }}
            </div>
            <div class="number" v-if="menu.type === 'ref'">
              {{ "(" + (menu.dataIds.length > 99 ? "99+" : menu.dataIds.length) + ")" }}
            </div>
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
    <sheet-menu-popper
      class="dropdown"
      ref="sheetMenuPopper"
      v-if="displayIndex !== menuList.length + 1"
      :menu-list="menuList.slice(displayIndex)"
      :cur-name.sync="activeName"
      @changeData="select"
    ></sheet-menu-popper>
  </div>
</template>

<script>
import SheetMenuPopper from "@/components/BaseComponents/SheetMenuPopper"
export default {
  name: "sheet-menu",
  components: { SheetMenuPopper },
  props: {
    menuList: Array,
    active: String
  },
  data() {
    return {
      activeName: "详细信息",
      clientWidth: 0
    }
  },
  mounted() {
    this.getClientWidth()
  },
  computed: {
    displayIndex() {
      let sumWidth = 20
      let index = this.menuList.length + 1
      for (let i = 0; i < this.menuList.length; i++) {
        if (i === 0) {
          sumWidth = sumWidth + 75 + 16
        } else {
          sumWidth = sumWidth + 100 + 16
        }
        if (sumWidth > this.clientWidth) {
          index = i
          break
        }
      }
      return index
    }
  },
  methods: {
    init() {
      this.activeName = this.active
    },
    getClientWidth() {
      let elementResizeDetectorMaker = require("element-resize-detector")
      let erd = elementResizeDetectorMaker()
      erd.listenTo(this.$refs.sheetMenu.$el, () => {
        this.clientWidth = this.$refs.sheetMenu.$el.clientWidth
      })
    },
    select(menu) {
      this.$emit("select", menu)
    }
  }
}
</script>

<style lang="scss" scoped>
.sheet-menu {
  display: flex;
  .display {
    width: 100%;
    color: $color-font-first;
    .nav-label {
      width: 75px;
      text-align: center;
    }
    .number {
      width: 25px;
      text-align: left;
    }
    ::v-deep {
      .el-tabs__item {
        padding: 0 8px;
        font-weight: unset;
        color: #606266;
        &.is-active {
          color: #409eff;
          font-weight: 500;
        }
      }
    }
  }
  .dropdown {
    position: absolute;
    right: 24px;
    top: 12px;
  }
}
</style>
